<mat-toolbar class="footer" *ngIf="!errorMenu && !callcenterMenu && !mobileMenu && !qrMenu">
    <mat-toolbar-row class="top-row">
      <div class="row complete-row align-items-center">
        <div class="col-12 col-lg-3">
          <ul class="terms-list">
            <li>
              <label class="lab linking cursor" routerLink="terms-conditions" data-test="terms-link">TÉRMINOS Y CONDICIONES</label>
            </li>
            <li>
              <label class="lab linking cursor" routerLink="FAQ" data-test="faq-link">PREGUNTAS FRECUENTES</label>
            </li>
            <li>
              <label class="lab linking cursor" routerLink="privacy-policy" data-test="privacy-link">AVISO DE PRIVACIDAD</label>
            </li>
          </ul>
        </div>

        <div class="col-12 col-lg-6 center-img">
          <img class="img-logo cursor" src="./assets/header-footer/footer_LogoToks.svg" alt="" (click)="goToLink('https://www.toks.com.mx/')" data-test="footer-btn-toks">&nbsp;
          <img class="img-fa cursor" src="./assets/header-footer/footer_LogoFarolito.svg" alt="" (click)="goToLink('https://elfarolito.com.mx/')" data-test="footer-btn-farolito">&nbsp;
          <img class="img-logo cursor" src="./assets/header-footer/footer_LogoPanda.svg" alt="" (click)="goToLink('https://www.pandaexpress.com.mx/es/')" data-test="footer-btn-panda">
        </div>
        <div class="col-12 col-lg-3 center-img">
          <img class="img-social cursor" src="./assets/header-footer/footer_LogoFace.svg" alt="" (click)="goToLink('https://www.facebook.com/A-Comer-Club-105305167609770/')" data-test="footer-btn-facebook">
          <img class="img-social cursor" src="./assets/header-footer/footer_LogoInstagram.svg" alt="" (click)="goToLink('https://www.instagram.com/a_comer_club/')" data-test="footer-btn-instagram">&nbsp;
          <img class="img-social-x cursor" src="./assets/header-footer/footer_LogoX.svg" alt="" (click)="goToLink('https://x.com/ClubComer')" data-test="footer-btn-x">&nbsp;
        </div>
      </div>
    </mat-toolbar-row>

    <mat-toolbar-row class="bottom-row">
      <div class="row complete-row">
        <div class="col-12">
          <label class="lab">© Todos los derechos reservados. A Comer Club 2026</label>
        </div>
      </div>
    </mat-toolbar-row>
  </mat-toolbar>
